// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/cues/v4/user_cues.proto (package wisetime.user.cues.v4, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/cues/v4/user_cues.proto.
 */
export const file_wisetime_user_cues_v4_user_cues: GenFile = /*@__PURE__*/
  fileDesc("CiV3aXNldGltZS91c2VyL2N1ZXMvdjQvdXNlcl9jdWVzLnByb3RvEhV3aXNldGltZS51c2VyLmN1ZXMudjQiFQoTTGlzdFVzZXJDdWVzUmVxdWVzdCJJChRMaXN0VXNlckN1ZXNSZXNwb25zZRIxCgl1c2VyX2N1ZXMYASADKAsyHi53aXNldGltZS51c2VyLmN1ZXMudjQuVXNlckN1ZSJIChRDcmVhdGVVc2VyQ3VlUmVxdWVzdBIwCgh1c2VyX2N1ZRgBIAEoCzIeLndpc2V0aW1lLnVzZXIuY3Vlcy52NC5Vc2VyQ3VlIlsKB1VzZXJDdWUSCgoCaWQYASABKAkSEwoLZGVzY3JpcHRpb24YAiABKAkSLwoLY3JlYXRlX3RpbWUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIiIKFERlbGV0ZVVzZXJDdWVSZXF1ZXN0EgoKAmlkGAEgASgJMq4CCg9Vc2VyQ3Vlc1NlcnZpY2USZwoMTGlzdFVzZXJDdWVzEioud2lzZXRpbWUudXNlci5jdWVzLnY0Lkxpc3RVc2VyQ3Vlc1JlcXVlc3QaKy53aXNldGltZS51c2VyLmN1ZXMudjQuTGlzdFVzZXJDdWVzUmVzcG9uc2USXAoNQ3JlYXRlVXNlckN1ZRIrLndpc2V0aW1lLnVzZXIuY3Vlcy52NC5DcmVhdGVVc2VyQ3VlUmVxdWVzdBoeLndpc2V0aW1lLnVzZXIuY3Vlcy52NC5Vc2VyQ3VlElQKDURlbGV0ZVVzZXJDdWUSKy53aXNldGltZS51c2VyLmN1ZXMudjQuRGVsZXRlVXNlckN1ZVJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHlCNwodY29tLndpc2V0aW1lLmFwaS51c2VyLmN1ZXMudjRCFFVzZXJDdWVzU2VydmljZVByb3RvUAFiBnByb3RvMw", [file_google_protobuf_empty, file_google_protobuf_timestamp]);

/**
 * Empty message. The current user will be matched via ID token.
 *
 * @generated from message wisetime.user.cues.v4.ListUserCuesRequest
 */
export type ListUserCuesRequest = Message<"wisetime.user.cues.v4.ListUserCuesRequest"> & {
};

/**
 * Describes the message wisetime.user.cues.v4.ListUserCuesRequest.
 * Use `create(ListUserCuesRequestSchema)` to create a new message.
 */
export const ListUserCuesRequestSchema: GenMessage<ListUserCuesRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_cues_v4_user_cues, 0);

/**
 * @generated from message wisetime.user.cues.v4.ListUserCuesResponse
 */
export type ListUserCuesResponse = Message<"wisetime.user.cues.v4.ListUserCuesResponse"> & {
  /**
   * @generated from field: repeated wisetime.user.cues.v4.UserCue user_cues = 1;
   */
  userCues: UserCue[];
};

/**
 * Describes the message wisetime.user.cues.v4.ListUserCuesResponse.
 * Use `create(ListUserCuesResponseSchema)` to create a new message.
 */
export const ListUserCuesResponseSchema: GenMessage<ListUserCuesResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_cues_v4_user_cues, 1);

/**
 * @generated from message wisetime.user.cues.v4.CreateUserCueRequest
 */
export type CreateUserCueRequest = Message<"wisetime.user.cues.v4.CreateUserCueRequest"> & {
  /**
   * @generated from field: wisetime.user.cues.v4.UserCue user_cue = 1;
   */
  userCue?: UserCue;
};

/**
 * Describes the message wisetime.user.cues.v4.CreateUserCueRequest.
 * Use `create(CreateUserCueRequestSchema)` to create a new message.
 */
export const CreateUserCueRequestSchema: GenMessage<CreateUserCueRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_cues_v4_user_cues, 2);

/**
 * @generated from message wisetime.user.cues.v4.UserCue
 */
export type UserCue = Message<"wisetime.user.cues.v4.UserCue"> & {
  /**
   * A unique identifier for the user cue, in lower-kebab-case format,
   * for example "trashed-time-row".
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * A description that explains what this user cue is about. For example,
   * "Shown when the user trashes a time row for the first time"
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * When the user cue was shown.
   * This field is optional when creating a UserCue.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 3;
   */
  createTime?: Timestamp;
};

/**
 * Describes the message wisetime.user.cues.v4.UserCue.
 * Use `create(UserCueSchema)` to create a new message.
 */
export const UserCueSchema: GenMessage<UserCue> = /*@__PURE__*/
  messageDesc(file_wisetime_user_cues_v4_user_cues, 3);

/**
 * @generated from message wisetime.user.cues.v4.DeleteUserCueRequest
 */
export type DeleteUserCueRequest = Message<"wisetime.user.cues.v4.DeleteUserCueRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message wisetime.user.cues.v4.DeleteUserCueRequest.
 * Use `create(DeleteUserCueRequestSchema)` to create a new message.
 */
export const DeleteUserCueRequestSchema: GenMessage<DeleteUserCueRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_cues_v4_user_cues, 4);

/**
 * Service to manage user cues that have been shown to the user.
 *
 * User cues are short messages, shown by AppCues or otherwise, that teach the user
 * how to use WiseTime. They may be shown as a result of a user action, or perhaps
 * when the user accesses a feature for the first time.
 *
 * For example, we may show a user cue when the user trashes a time row for the first
 * time, to let them know how they can view trashed items and permanently delete them.
 * In order to only show this message once, the app can:
 *
 * - Check whether a user cue with ID "trashed-time-row" exists for the user, by
 *   calling the ListUserCues RPC
 * - If none exists, show the cue message to the user
 * - Store the fact that the message has been shown to the user, by calling the
 *   CreateUserCue RPC, and creating a UserCue with id "trashed-time-row"
 *
 * @generated from service wisetime.user.cues.v4.UserCuesService
 */
export const UserCuesService: GenService<{
  /**
   * List user cues that have been shown to the current user.
   *
   * @generated from rpc wisetime.user.cues.v4.UserCuesService.ListUserCues
   */
  listUserCues: {
    methodKind: "unary";
    input: typeof ListUserCuesRequestSchema;
    output: typeof ListUserCuesResponseSchema;
  },
  /**
   * Store the fact that we have shown a cue to the current user.
   *
   * @generated from rpc wisetime.user.cues.v4.UserCuesService.CreateUserCue
   */
  createUserCue: {
    methodKind: "unary";
    input: typeof CreateUserCueRequestSchema;
    output: typeof UserCueSchema;
  },
  /**
   * Reset the fact that we have already shown a cue to the current user.
   *
   * @generated from rpc wisetime.user.cues.v4.UserCuesService.DeleteUserCue
   */
  deleteUserCue: {
    methodKind: "unary";
    input: typeof DeleteUserCueRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wisetime_user_cues_v4_user_cues, 0);

